/* 画像プレビュー画面 */
import React from 'react';
import { Button, Modal } from 'react-bootstrap';
var PreviewModal = function (_a) {
    var show = _a.show, image_source = _a.image_source, image_width = _a.image_width, image_height = _a.image_height, handleOnclick = _a.handleOnclick;
    return (React.createElement(Modal, { id: "preview_modal", size: "sm", centered: true, show: show, animation: false, onHide: handleOnclick },
        React.createElement(Button, { className: "close-button", onClick: handleOnclick }),
        React.createElement("img", { src: image_source, height: image_height, width: image_width })));
};
export default PreviewModal;
